import React, { useState, useEffect } from 'react';
// import io, { Socket } from 'socket.io-client';
import { useChatAssistantApi } from '../../store/api/hooks/chatAssistantApiHook';
import Icon from '../../components/icons';
import Spinner from '../../components/iconSvgs/spinner';
import { Message } from '../../_config/interfaces/interfaces';

// const socket: Socket = io('https://hubwallet-dev.dreamztesting.com/');

const ChatAssistant: React.FC = () => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('');
    const [apiMessages, setApiMessages] = useState<Message[]>([]);

    const chatAssistantAPI: any = useChatAssistantApi();

    useEffect(() => {

    }, [apiMessages]);

    useEffect(() => {

        setOnSubmitLoading(true);
        setTimeout(() => {
            setOnSubmitLoading(false);
        }, 2000);
        // socket.on('chatMessage', (msg: string) => {
        //     setMessages((prevMessages) => [...prevMessages, msg]);
        // });

        // return () => {
        //     socket.off('chatMessage'); // Cleanup when the component unmounts
        // };
    }, []);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            sendMessage();
        }
    };

    const sendMessage = () => {
        if (message) {
            let obj = { sender: 'user', msg: message, img: '/assets/images/no-profile.jpg' };
            setApiMessages(prevMessages => [...prevMessages, obj]);
        }
        setOnSubmitLoading(true);
        // if (message.trim()) {
        //     socket.emit('chatMessage', message); // Emit the message to the server
        //     setMessage(''); // Clear the input after sending
        // }
        const param = {
            question: message
        }
        try {
            chatAssistantAPI.postQuery(param, (msg: any, resp: any) => {
                if (resp?.code === 201 || resp?.code === 200) {
                    // setApiMessages([...apiMessages, resp?.result?.summary]);
                    // getMessages(resp?.result?.summary);
                }
                setApiMessages(prevMessages => [...prevMessages, { sender: 'bot', msg: resp?.result?.summary, img: '/assets/images/bot-avatar.png' }]);
                setOnSubmitLoading(false);
                setMessage('');

            }, (error: any, resp: any) => {
                if (resp?.detail?.code === 400) {

                }
                setOnSubmitLoading(false);
                setMessage('');
            });
        } catch (e) {
            console.log('error =>', e);
            setOnSubmitLoading(false);
            setMessage('');
        }
    };

    return (
        <>
            <div className="bg-white shadow-none rounded-2xl p-6 flex flex-col w-full h-screen ipad-padding-0">
                {isOnSubmitLoading && (
                    <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                        <Spinner className="self-center z-50" />
                    </div>
                )}
                {/* Chat Messages */}
                <div className="messages flex-grow mb-4">
                    {apiMessages.length === 0 ? (
                        <div className="flex justify-center items-center w-full h-full bg-white">
                            <p className="text-center text-gray-500 text-2xl font-semibold">How can I help you today?</p>
                        </div>
                    ) : (
                        apiMessages.map((msg: any, index) => (
                            <>
                                {msg.sender === 'bot' && (
                                    <div
                                        key={index}
                                        className="flex mb-4 p-2 rounded-lg text-sm text-gray-600 justify-start"
                                    >
                                        <img
                                            className="w-[50px] h-[50px] bg-gray-100 rounded-full"
                                            src={msg.img}
                                            alt={`${msg.sender}-avatar`}
                                        />
                                        <div className="bg-blue-50 p-3 rounded-md max-w-[60%]">{msg.msg}</div>
                                    </div>
                                )}
                                {msg.sender === 'user' && (
                                    <div
                                        key={index}
                                        className="flex mb-4 p-4 rounded-lg text-sm text-gray-600 justify-end"
                                    >
                                        <div className="bg-blue-50 p-3 mr-2 rounded-md max-w-[60%]">{msg.msg}</div>
                                        <img
                                            className="w-[40px] h-[40px] bg-gray-100 rounded-full"
                                            src={msg.img}
                                            alt={`${msg.sender}-avatar`}
                                        />
                                    </div>
                                )}
                            </>
                        ))
                    )}
                </div>


                <div className="flex justify-center items-center query-container fixed bottom-0 bg-gray-100 p-2">
                    <input
                        className="flex-grow p-2 block-lg w-full border-gray-100 rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-800 outline outline-1 -outline-offset-1 placeholder:text-gray-400 focus:outline-1 focus:-outline-offset-1 focus:outline-gray-400 sm:text-sm"
                        type="text"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Type a query..."
                    />

                    {/* Send Icon */}
                    <Icon
                        name="send"
                        onClick={sendMessage}
                        className="ml-2 text-gray-400 cursor-pointer"
                    />
                </div>

            </div>

        </>
    );
};

export default ChatAssistant;
